import VDBText from "@components/atoms/Text";
import { Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import SectionContainer from "./SectionContiner";
import styled from "styled-components/native";
import { useDefaultSearchGroup } from "../../../../hooks/useDefaultSearchGroup";
import { css } from "styled-components/native";
import LayoutContainer from "@components/layout/LayoutContainer";
import { useEffect } from "react";
import { useNavigation } from "@react-navigation/native";

type DefaultSearchGroupScreenProps = {
  removeExtraSpacing?: boolean;
};

const DefaultSearchGroupScreen = ({
  removeExtraSpacing,
}: DefaultSearchGroupScreenProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const updatedSection = useDefaultSearchGroup();
  const navigation = useNavigation();

  useEffect(() => {
    if (!theme.isMobile) {
      navigation.setOptions({
        headerLeft: () => <></>,
      });
    }
  }, [theme.isMobile]);

  return (
    <>
      <LayoutContainer>
        <OverLay removeExtraSpacing={removeExtraSpacing}>
          {!removeExtraSpacing && <Spacer size={SpaceType.ExtraLarge} />}
          <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
            {t("searchGroup.screenText.header.text")}
          </VDBText>
          <Spacer size={SpaceType.Big} />
          {updatedSection.map((sectionData, index) => (
            <SectionContainer key={index} data={sectionData.data} />
          ))}
          {!removeExtraSpacing && <Spacer size={SpaceType.ExtraSmall} />}
        </OverLay>
      </LayoutContainer>
    </>
  );
};

const OverLay = styled.View<{ removeExtraSpacing?: boolean }>`
  padding-horizontal: ${({ theme, removeExtraSpacing }) =>
    theme.isMobile ? 16 : !removeExtraSpacing ? 40 : 0}px;
  ${({ theme, removeExtraSpacing }) =>
    (theme.isTablet || theme.isMobile) &&
    !removeExtraSpacing &&
    css`
      margin-top: 0px;
    `}
`;

export default DefaultSearchGroupScreen;
